"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var DomainObject_1 = require("../../../core/model/DomainObject");

var DashboardReportType_1 = require("../DashboardReportType");

var NewSalesDashboardReport =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(NewSalesDashboardReport, _DomainObject_1$Domai);

  /**
   *
   * @param id Report unique identifier
   * @param root Root node of report tree.
   * @param type
   * @param userCategories
   * @param completed State of report. True if report is already created.
   * @param error
   * @param filter
   * @param rootMapping
   */
  function NewSalesDashboardReport(id, root, type, userCategories, completed, error, filter, rootMapping) {
    var _this;

    _classCallCheck(this, NewSalesDashboardReport);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(NewSalesDashboardReport).call(this));
    _this.id = id;
    _this.root = root;
    _this.type = type;
    _this.userCategories = userCategories;
    _this.completed = completed;
    _this.error = error;
    _this.filter = filter;
    _this.rootMapping = rootMapping;
    return _this;
  }

  return NewSalesDashboardReport;
}(DomainObject_1.DomainObject);

exports.NewSalesDashboardReport = NewSalesDashboardReport;
NewSalesDashboardReport.DUMMY = new NewSalesDashboardReport('', {
  id: '',
  parentId: null,
  children: [],
  level: 1
}, DashboardReportType_1.DashboardReportType.Regular, 'allAllowed', false, null, {}, immutable_1.Map());